declare global {
  interface Window {
    __SYNCBASE_RUNTIME_CONFIG__?: Record<string, string>;
  }
}

export type AppEnv = 'prod' | 'test' | 'dev';

export interface EnvColors {
  sidebarBackground: string;
  sidebarBorder: string;
  sidebarText: string;
  badge: string;
  badgeText: string;
}

const ENV_COLOR_MAP: Record<AppEnv, EnvColors> = {
  prod: {
    sidebarBackground: '#ffffff',
    sidebarBorder: '#e0e0e0',
    sidebarText: '#212121',
    badge: '',
    badgeText: '',
  },
  test: {
    sidebarBackground: '#e3f2fd',
    sidebarBorder: '#1976d2',
    sidebarText: '#0d47a1',
    badge: '#1976d2',
    badgeText: '#ffffff',
  },
  dev: {
    sidebarBackground: '#e8f5e9',
    sidebarBorder: '#388e3c',
    sidebarText: '#1b5e20',
    badge: '#388e3c',
    badgeText: '#ffffff',
  },
};

/** Resolves app environment from VITE_DEPLOY_ENV (local → dev, test → test, prod → prod). */
export function getAppEnv(): AppEnv {
  const raw = getRuntimeEnvValue('VITE_DEPLOY_ENV')?.toLowerCase();
  if (raw === 'test') return 'test';
  if (raw === 'local') return 'dev';
  return 'prod';
}

export function getEnvColors(): EnvColors {
  return ENV_COLOR_MAP[getAppEnv()];
}

export function getRuntimeEnvValue(key: string): string | undefined {
  if (typeof window !== 'undefined') {
    const runtimeConfig = window.__SYNCBASE_RUNTIME_CONFIG__;
    const runtimeValue = runtimeConfig?.[key];
    if (typeof runtimeValue === 'string' && runtimeValue.length > 0) {
      return runtimeValue;
    }
  }

  const viteValue = (import.meta as any).env?.[key];
  if (viteValue !== undefined && viteValue !== null && String(viteValue).length > 0) {
    return String(viteValue);
  }

  if (typeof process !== 'undefined' && (process as any)?.env) {
    const processValue = (process as any).env[key];
    if (processValue !== undefined && processValue !== null && String(processValue).length > 0) {
      return String(processValue);
    }
  }

  return undefined;
}
